import type { MouseEvent as ReactMouseEvent } from 'react'
import { KibButtonNew } from '@chewy/kib-controls-react'
import classNames from 'classnames'

import type { PopperAction } from './ActionsPopper'

import '@chewy/kib-controls-styles/dist/styles/kib-button-new.css'
import styles from './RhapActionsPopper.module.scss'

/**
 * Renders a menu item button for RhapActionsPopper components.
 * Shared utility to avoid code duplication between RhapActionsPopper and RhapActionsPopperPortaled.
 *
 * @param action - The popper action configuration
 * @param onClose - Optional callback to close the popper when item is clicked
 * @returns A KibButtonNew component configured as a menu item
 */
export const renderRhapActionsMenuItem = ({
  label = '',
  onClick,
  redText,
  disabled,
  onClose,
}: PopperAction & { onClose?: () => void }) => {
  const handleClick = (event: ReactMouseEvent<HTMLButtonElement>) => {
    // Early return if disabled or if there's no action handler
    if (disabled || (onClick === undefined && onClose === undefined)) return
    if (onClick) onClick(event)
    if (onClose) onClose()
  }

  const isDisabled =
    disabled || (onClick === undefined && onClose === undefined)

  return (
    <KibButtonNew
      className={classNames(styles.menuButton, {
        [styles.redTextColor]: redText,
      })}
      disabled={isDisabled}
      emphasis="tertiary"
      theme="utility"
      onClick={handleClick}
    >
      {label}
    </KibButtonNew>
  )
}
